module.exports = __webpack_public_path__ + "static/media/samtrafiken_footer.969d0861.svg";